import { render, staticRenderFns } from "./CourseCategoryListAddNew.vue?vue&type=template&id=6e220295&"
import script from "./CourseCategoryListAddNew.vue?vue&type=script&lang=js&"
export * from "./CourseCategoryListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CourseCategoryListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports